"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useCountryFetch;
var _react = require("react");
function useCountryFetch(store, openDialog) {
  (0, _react.useEffect)(function () {
    if (openDialog) {
      store.appStore.country.fetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openDialog]);
}